<script lang="ts" setup>
import { ButtonBack } from '@brighterly/lib-lumee-ui'

import { useAssessmentTestStore } from '@stores/assessment-test'

import { useAssessmentTestControl } from '@hooks/assessments/assessment-test-control.hook'

defineOptions({
  name: 'BtnPrevStepAssessment',
})

const assessmentTestStore = useAssessmentTestStore()

const {
  setPrevStep,
} = useAssessmentTestControl()

</script>

<template>
  <div class="assessment-btn-prev">
    <ButtonBack
      v-if="assessmentTestStore.getCurrentQuestionIndex > 0"
      view="default"
      aria-label="Previous question"
      @click="setPrevStep"
    />
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/Assessment/BtnPrevStepAssessment.scss" />
